import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "selected-spending-limit" }
const _hoisted_2 = { class: "value" }
const _hoisted_3 = { class: "button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gs_button = _resolveComponent("gs-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.t('new_spending_limit')), 1),
      _createElementVNode("strong", _hoisted_2, " $ " + _toDisplayString(_ctx.formatNumberByLocale(_ctx.selectedStore?.spendingLimit?.pendingLimit ?? 0)) + " US Dollars ", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_gs_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
        icon: "mdi-chevron-left",
        size: "large",
        type: "outlined"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('CommonUi.back')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_gs_button, {
        onClick: _ctx.goToShopifyUrl,
        type: "primary",
        size: "large",
        "full-width": ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('proceed_to_shopify')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (!_ctx.selectedPlan && !_ctx.account.userFromMarketplace)
      ? (_openBlock(), _createBlock(_component_gs_button, {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel'))),
          class: "mt-2",
          "full-width": "",
          type: "info",
          size: "large"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('cancel_shopify_integration')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}